
import { environment } from 'src/environments/environment';
import { Configuration, BrowserCacheLocation, LogLevel, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId,
    authority: environment.authority,
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.postLogoutRedirectUri,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowPlatformBroker: false,
    loggerOptions: {
      logLevel: LogLevel.Info,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Optional: Verbose during debugging
        // console.log(message);
      }
    }
  }
};

// Base OIDC + Graph scope
const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access', 'User.Read']
};

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: loginRequest
};

// 🔧 IMPORTANT: Use Popup here to avoid full-page redirect loops from the interceptor.
export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Popup,
  protectedResourceMap: new Map<string, string[]>([
    ['https://graph.microsoft.com/v1.0/me', ['User.Read']],

    // ✅ Only protect actual API endpoints (avoid accidentally matching your app shell URLs)
    // If your API is served elsewhere (e.g., http://localhost:5000), use that base.
    // If it is http://localhost:4200/api, make sure you don’t have other calls to / that match.
    [environment.apiUrl, ['api://7300b0fb-ec72-4e3b-a175-98a5202230ed/access_as_user']],
  ])
};